class SlideShow {
    constructor() {
        this.init();
    }
    init = () => {
        let sliders = document.querySelectorAll('.main-slider-swiper');
        sliders.forEach((item)=>{
            let speed = item?.dataset.speed ? parseInt(item?.dataset.speed) * 1000 : 3000;
            let arrow = item?.dataset.arrow == "true" ? true : false;
            let autoPlay = item?.dataset.autoplay == "true" ? true : false;
            let loop = item?.dataset.loop == "true"  ? true : false;
            let paginate = item?.dataset.paginate == "true"  ? true : false;
            let paginateType = item?.dataset.paginateType;
            
            let settings = {
                loop: loop,
                slidesPerView: 1,
                autoHeight: true,
                autoplay: autoPlay,
                speed,
            }
            if(arrow){
                settings['navigation'] = {
                    nextEl: item.querySelector('.swiper-button-next'),
                    prevEl: item.querySelector('.swiper-button-prev')
                }
            }
            if(paginate){
                if(paginateType == '3'){
                    settings['pagination'] = {
                        type: "fraction",
                        el:  item.querySelector('.swiper-pagination'),
                    }
                }else if(paginateType == '2'){
                    settings['pagination'] = {
                        dynamicBullets: true,
                        el: item.querySelector('.swiper-pagination'),
                    }
                }else{
                    settings['pagination'] = {
                        el: item.querySelector('.swiper-pagination'),
                    }
                }
            }
            const swiper = new Swiper(item, settings);
        })
    }
}
if (document.querySelector('.main-slider-swiper')) new SlideShow();